let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ffEVr"), load("c0FMs")]).then(() => parcelRequire('cX5zm'));